module.exports = __webpack_public_path__ + "img/wj.af0dd341.png";